var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg03Planes(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 258,
    height: 197,
    viewBox: "0 0 258 197",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_343",
    "data-name": "Grupo 343",
    transform: "translate(-975 -1136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_263",
    "data-name": "Rect\\xE1ngulo 263",
    width: 258,
    height: 197,
    transform: "translate(975 1136)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_339",
    "data-name": "Grupo 339"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_27",
    "data-name": "Elipse 27",
    cx: 52.5,
    cy: 52.5,
    r: 52.5,
    transform: "translate(1063 1202)",
    fill: "#fbeaf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_275",
    "data-name": "Grupo 275",
    transform: "translate(-789.598 -94.434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_266",
    "data-name": "Grupo 266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_256",
    "data-name": "Grupo 256"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_171",
    "data-name": "Rect\\xE1ngulo 171",
    width: 48,
    height: 66,
    transform: "translate(1859.878 1292.399)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAAETCAYAAABz1knGAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAPWSURBVHhe7ddBUupQEEBRceZmLPe/CsvNOOSXChZqckkgfDGcMzETHfW1X2+22+3dpbw+v1zuj8POw9PjZve5uMUDEQW/aelYFgtEGFyTpUI5OxBhcM3ODeXkQITBX3JqKCcFIg7+qrmhzApEGKzBnEjudz+PEgdrMWeWJwUiDtZm6kwfDUQcrNWU2c5AxMHaHZvxyTcIrFVFMhqI7QEjgYiDWzM28z8CEQe3amj23SAQvgRie3Drvjdgg0D4DMT2gA+HLdggEAQCA/Zb5D0QzysYZoNAEAgEgcCIt9Pj3v0B42wQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCAKBIBAIAoEgEAgCgSAQCPcPT4+b3TfwjQ0CI96Wh0AgCATCeyDuEBhmg8CA/dIQCITPQDyz4MNhCzYIhC+B2CLcuu8N2CAQfgRii3CrhmZ/cIOIhFszNvOjTyyRgBsEchlkILYIa3dsxo9uEJGwVlNme9ITSySszdSZnnyDiIS1mDPLm+12u/uc7vX5Zf4vwRWY+4/+pEDeiIS/5NQX0MmB7AmFa3buaXB2IHtC4doscTcvFsieUPhNS0RxaPFADomF/2HpKA5dNJBjBMRUl4xg3N3dPyKIu+8pv3XxAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_172",
    "data-name": "Rect\\xE1ngulo 172",
    width: 49.92,
    height: 68.16,
    transform: "translate(1858.918 1291.198)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANAAAAEcCAYAAAC2+ToPAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAATSSURBVHhe7dpBWtMAGEVRYC1OdP9r0Yl7qV+UaoGCSW6SNuGciYy0g//6kurj6XR6uKVvX77e9gOwa99//nh8/vEmNgtIKGxpq7BWDUg03IM1Y1olIOFwr5aOabGARMOeLBXSIgGJh72qIaWAhMMRlIienn+dTDwcRbnlWQskHo5q6hpNCkg4fAZTIhod0NLxLPUtCJwteaNj73NUQEt8MMGwpa1u9r8B1Q8iHG5p7ftdLSDhcE9KSB/d8odfY4uHoxhuco27fHeB5sQjHPZgydu+ukDi4cjm3Op7Tcz+nwiXxMPeLHWzbwKauj7iYa+m3u61NtICiYe9qxG9CGjOuw/sXRmC2QtkffisLofmb0BT1kc8HM3cm07vQHAkcyKaHJD1gX9PbL8D8uUB/DF1ICYtkPWBl7wDwStjh2J4chsdkPWBt568/8B8HuEgEBBcMfaVZVRA3n/gOgsEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEAoJAQBAICAIBQSAgCAQEgYAgEBAEowL69uXr6flH4IIFgivGjoaAIHj6/vPH4/PPwESjF8h7ELzlEQ5eGTsWw9PbpICsELz0OyDvQfDH1JGY/AhnheDf6HgHgmdzxuFvQFMe46wQRzP3pi0QTHQ5Ni8CskJ8RuWW0wKJiL2besOvR+ZNQFNWaCAi9qrGM1jkHUhE7M1SN3s1oKkrNBARezHnVt9r4vF0ev/3mhvFnABhC0vGM/jwEW5uCNaIezPc5Bp3+eECDeofao24pbXv978BDZYoV0hsaaubHRXQYMn5ExNruMWNjg5osOQHhHs15S/4SQGdCYmjmvp0NOsfUj2CcURz7nrWAp1ZIo6gDEIK6ExI7FV9mlokoIGI2JOlXkMWC+hMSNyzpd/fFw/okpi4B0tHc2nVgC6JiS2tGc2lzQJ6j7CotorlrYeHX9PwetzyquruAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_257",
    "data-name": "Grupo 257"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_173",
    "data-name": "Rect\\xE1ngulo 173",
    width: 23.04,
    height: 2.16,
    transform: "translate(1872.598 1300.798)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAAAJCAYAAADNYymqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABWSURBVEhL7daxDcAgDERRm1VIEbL/LKHJLo4MYgVf81+Bqe9kyR4Rlp5r7A9KvN/0nC0fwq93MvfRb8IXWhsAHQoQowAxChBr5xxCvcx+bQAl1NuZm/3APBWV5nVbuAAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_258",
    "data-name": "Grupo 258"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_174",
    "data-name": "Rect\\xE1ngulo 174",
    width: 2.16,
    height: 32.88,
    transform: "translate(1868.758 1311.119)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAACJCAYAAAD+IRLIAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABiSURBVFhH7dixEYAgDEbhwAZOZueQdkzmCPGPgAV3SGvxXkOK70Kf5O4WXWepw9B27OlBM9DLKxDl9n4GAoEUCARSIBBIgUAgBQKBFAgEUr9EcT1r87TlpvcE1xsvbfUXsxsxnhoHJOMuagAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_259",
    "data-name": "Grupo 259"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1930",
    "data-name": "Trazado 1930",
    d: "M1888.111,1377.494a7.455,7.455,0,0,1-7.448-7.446v-50.861a7.455,7.455,0,0,1,7.448-7.445h23.463a2.3,2.3,0,0,1,1.626.674l14.616,14.615a2.3,2.3,0,0,1,.673,1.626v41.391a7.454,7.454,0,0,1-7.448,7.446Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_175",
    "data-name": "Rect\\xE1ngulo 175",
    width: 50.16,
    height: 67.92,
    transform: "translate(1879.558 1310.639)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANEAAAEbCAYAAABEPmGJAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAVeSURBVHhe7dlLQhNbFEBRYCx2dP5j0Y5z4b1SohACpmpXJfVZq2NaklB3e86Nj8/Pzw+39u3L19v/UJLvP388vrzkzE0iEs1+iOm9xSISzr6J6a/ZIxLPcQjpt9kiEs8xCWmGiMTD0UN6evlzEgExOPo5mDSJxMMlR51IoyeRgPjIUc/GqEm01C/J5XR9yrM+2vO8OqK5AhLMtkx97kd6zldFVAMSzrYJ6XP/jMhYZyCkj336xYKAOJn6POsWswXp/4kuGX7ZAtonIV32YURTPrh49k9I712MSEB8RkhvzbLOCeh4hPTXu4jGfkgBHZeQfkuTSEAI6SyiMR9MQJwcPaRZ7kRw5JD+RGQKUR01pNGTSEB85oghWeeY3dFC+hXRtW/eFOJaRwrJJGIxRwlJRCzqCCFdHZFVjqn2HtLTFndQtmfPIVnnuJm9hiQibmqPIV0VkfsQc9pbSCYRd7GnkETE3ewlJBFxV3sISUTc3dZDEhGrsOWQRMRqbDUkEbEqWwxJRKzO1kISEau0pZBExGptJSQRsWpbCElErN7aQxIRm7DmkETEZqw1JBGxKWsMSURsztpCEhGbtKaQRMRmrSUkEbFpawhJRGzevUMSEbtwz5BExG7cKyQRsSv3CElE7M6tQxIRu3TLkETEbt0qJBGxa7cISUTs3tIhiYhDWDIkEXEYS4UkIg5liZBExOHMHZKIOKQ5QxIRhzVXSCLi0OYISUQc3tSQTkQE/5sS0mkaiQheTJ1IIoJXpoQkIjgzNiQRwQXXhjTci0QEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEkYggEhFEIoJIRBCJCCIRQSQiiEQEwfefPx6viujbl6/PLy+BMyYRRCKCC8ZsX0/DTvfyGpjg6knkXgSXWefgzNiBISKY6HQV+hXRtfciKx28ZxLBK1MGxeiITCN4u739ichX3Rzd1AExaZ0zjdibMWf6fOC8iWjMNBIS/Ja+WBASe1Cm0OBdRGPvRkJiy+Y4v2kSnQiJLRp7bj8aMBcjGjuNBkJiS+Y8r4/Pzx//XVN+0JQA4VamxvPZuZ5lnXvNRGKtlgho8OkkGpQoTCXWYOkz/M+IBnW6iIl7mGMrmi2iwRxvaCAolnbrs3p1RIO53tyJoJjD3OdyMOZsjoposMQbhjUZ+4/76IgGQmKPpm5Gk77itoaxN+VMT5pEr5lKbF0dCjmiEzGxNXNtVLNFNBASWzD3dWTWiF4TFGuz1F1+sYhOxMQ9LRXOa4tHdE5ULOkW0bz18PAfkdU19YV3T0wAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_260",
    "data-name": "Grupo 260"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_1931",
    "data-name": "Trazado 1931",
    d: "M1912.837,1311.742c-1.169,0-.963.925-.963,3.418v9.179a4.762,4.762,0,0,0,4.762,4.762h8.435c3.856,0,4.29-2.777,2.046-5.022l-10.964-10.964a4.691,4.691,0,0,0-3.316-1.373Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_176",
    "data-name": "Rect\\xE1ngulo 176",
    width: 18.96,
    height: 19.68,
    transform: "translate(1910.758 1310.639)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABSCAYAAAAVfInDAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAImSURBVHhe7dxLdsIwDIXhhK20g9L9r6WddC/puRQXEwzx29KV/wk9zPJVtjJi3bZt8ft8P99/8aKvn+/1+qfJ7vBS4PZZhPzHK4Hzs4R4wasF52cB8XT9rF6Lf4i01vPbR/OHZJ3CZpPnxzqFXfAQI2A3PMQGGIVX885iAoxaGCG8UgSGJZJ9bPHwJQAME1h851kGrLIwSqZQM2DVbWsNsCoesgRYHQ9ZAWyChywANsND7IBN8RAzYHM8xArYBQ8xAnbDQ2yAXfEQE2B3PMQCOAQPMQAOw0PaAYfiIc2Aw/GQVkAReEgjoBg8pA1QFB7SBCgOD2kBFImHNACKxUPSAUXjIcmA4vGQVEAVeEgioBo8JA1QFR6SBKgOD0kBVImHJACqxUOjAVXjoZGA6vHQKEAKPDQCkAYP9QakwkM9AenwUC9ASjzUA5AWD7UGpMZDLQHp8VArQBN4qAWgGTxUG9AUHsoFDGUOD+UAhqbPJB6qARiFd7R1tFZ6hM1OnisV0B8k83godwInXkZu+qLxWO89V870nUovTaZSLZKOLfv0pTbvvF2x04dBuuCljOucvltZkzcB/8o+thPQw8vZuoyAKc9U9Gu1fgyvPCnPjuethuenCbJkWB7wUA1A9oAXXBgMR7Blzufptp2Ax718VZmAj/kmh+95E/DW3uIQD03AsEFw277K4iZ+NjzJeC4LiEcnLhvPxYgYe00V44XSBJp/ny/LL8mIaLy2K96JAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_261",
    "data-name": "Grupo 261"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_177",
    "data-name": "Rect\\xE1ngulo 177",
    width: 25.68,
    height: 2.16,
    transform: "translate(1891.798 1335.359)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAJCAYAAAA1g9JdAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABWSURBVFhH7dfBDYAwCEZh6Cr2YLv/LHpxFxqMpivwJ++7MMALCXhE2OwjDGVdz+05fRwnoQRkMGIJad+EAGIJIZYQYonIA6P9ZyHqe/+sxK9V014mswViwBiNh/9uhwAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_262",
    "data-name": "Grupo 262"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_178",
    "data-name": "Rect\\xE1ngulo 178",
    width: 25.68,
    height: 2.16,
    transform: "translate(1891.798 1343.999)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAJCAYAAAA1g9JdAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABTSURBVFhH7dbBDYAwDARBO63AI6H/WuBDL0ZOQg8+aedzBaws2SPCrnOEoaz7fTzXx9EJJSCDEUtI2wsBxBJCLCHEEpEPRvvfQtQ3L4tgta0+Zh8t9xal7/IW2QAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_263",
    "data-name": "Grupo 263"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_179",
    "data-name": "Rect\\xE1ngulo 179",
    width: 25.68,
    height: 2.16,
    transform: "translate(1891.798 1352.639)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAJCAYAAAA1g9JdAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABTSURBVFhH7dbBDYAwDARBO63AI6H/WuBDL0ZOQg8+aedzBaws2SPCrnOEoaz7fTzXx9EJJSCDEUtI2wsBxBJCLCHEEtL+txC1Zad5WQSrbfUx+wDsahals2iP6wAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_264",
    "data-name": "Grupo 264"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_180",
    "data-name": "Rect\\xE1ngulo 180",
    width: 25.68,
    height: 2.16,
    transform: "translate(1891.798 1361.278)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGsAAAAJCAYAAAA1g9JdAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABTSURBVFhH7dexDcAgDAVRm1VIEdh/FmiyiyOD2IEv3SvA/QkJe0RY6k/bA64zvul5lzwIdbfTx1t9CSVivSxoIJYQYgkhlhBiicjvO3uWgL1nmf0dYhTz/3fwjQAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_265",
    "data-name": "Grupo 265"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rect\\xE1ngulo_181",
    "data-name": "Rect\\xE1ngulo 181",
    width: 11.52,
    height: 2.4,
    transform: "translate(1891.798 1318.798)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAKCAYAAADy491MAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAABXSURBVEhLY/z//z8DMni/aiOqwCADgmH+jFAmGIA9MNgdjQ3APMIE5g1BAAt0xncrNwy50EcGQzYGYGDUAwMNhrQHQCURE3q5OtQASkU2VOoDRKAzMAAAY7IdBf0NUcMAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_59",
    "data-name": "Grupo 59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_58",
    "data-name": "Grupo 58"
  }, /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_20",
    "data-name": "L\\xEDnea 20",
    y2: 19.18,
    transform: "translate(1815.208 1301.869)",
    fill: "none",
    stroke: "#051518",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.037
  }), /*#__PURE__*/React.createElement("line", {
    id: "L\\xEDnea_21",
    "data-name": "L\\xEDnea 21",
    x2: 19.184,
    transform: "translate(1805.615 1311.459)",
    fill: "none",
    stroke: "#051518",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.037
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_54",
    "data-name": "Trazado 54",
    d: "M1918.13,1252.317a7.882,7.882,0,1,0,7.882-7.883A7.882,7.882,0,0,0,1918.13,1252.317Z",
    fill: "none",
    stroke: "#051518",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2.037
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03Planes);
export default __webpack_public_path__ + "static/media/03planes.81eae8e38960c0e2ab0cce89b23658bd.svg";
export { ForwardRef as ReactComponent };